import React from 'react';
import MessageBox from '../../../../uikit/info/MessageBox';
import { Spacer } from '../../../../uikit/misc/Spacer';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
var t = getTranslation(translations);
export default function SchufaNeutralMessageBox() {
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageBox, { title: t.title, description: t.content, content: t.modalContent }),
        React.createElement(Spacer, { size: 3 })));
}
